import msgpack from "msgpack-lite";
import dayjs from "@/plugins/dayjs";
import {dayjsPacker, dayjsUnpacker} from "./datetime";

const codec = msgpack.createCodec();
codec.addExtPacker(77, dayjs, dayjsPacker);
codec.addExtUnpacker(77, dayjsUnpacker);
export default codec;
